const dateTimeFormats = {
  "en-US": {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    },
    monthShort: {
      month: "short"
    },
    monthLong: {
      month: "long"
    },
    day: {
      day: "2-digit"
    },
    year: {
      year: "numeric"
    }
  },
  "zh-CN": {
    short: {
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: true
    },
    monthShort: {
      month: "short"
    },
    monthLong: {
      month: "long"
    },
    day: {
      day: "2-digit"
    },
    year: {
      year: "numeric"
    }
  },
  "zh-HK": {
    short: {
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: true
    },
    monthShort: {
      month: "short"
    },
    monthLong: {
      month: "long"
    },
    day: {
      day: "2-digit"
    },
    year: {
      year: "numeric"
    }
  }
};

export default dateTimeFormats;
